/**
 * Дані картки необоротного активу для сервера (ч.1117).
 *
 * Винесено зі сторінки, щоб контракт «що надсилає картка» мав тест: до ч.1117
 * «зберегти» в НАЯВНІЙ картці давало 422 — картка надсилала організацію,
 * інвентарний номер, групу й метод амортизації, а схема оновлення їх не
 * приймала. Тепер: організація — лише при створенні (змінити її не можна);
 * номер, група й метод ідуть і на оновлення (сервер перевіряє, що групу й
 * метод міняють лише до введення в експлуатацію).
 */
export interface AssetCardForm {
  organization_id: string;
  inventory_number: string;
  name: string;
  asset_group_id: string;
  depreciation_method_id: string;
  primary_cost: string;
  liquidation_value: string;
  useful_life_months: string;
  expense_account_code: string;
  department_id: string;
  tax_purpose_id: string;
  responsible_employee_id: string;
  comment: string;
  ukt_zed_code: string;
  account_code: string;
  depreciation_account_code: string;
  write_off_method: string;
  quantity: string;
  /** ч.1388: податковий облік амортизації (лише ОЗ і НМА). */
  tax_depreciable: boolean;
  tax_useful_life_months: string;
  tax_primary_cost: string;
  tax_accumulated_depreciation: string;
  tax_accelerated: boolean;
}

export function assetCardPayload(
  f: AssetCardForm,
  opts: { orgId: string; isLv: boolean; forUpdate: boolean; isIa?: boolean },
): Record<string, unknown> {
  const base: Record<string, unknown> = {
    inventory_number: f.inventory_number || null,
    name: f.name.trim(),
    primary_cost: f.primary_cost,
    expense_account_code: f.expense_account_code,
    department_id: f.department_id || null,
    responsible_employee_id: f.responsible_employee_id || null,
    comment: f.comment || null,
    account_code: f.account_code.trim() || null,
    tax_purpose_id: f.tax_purpose_id || null,
    ...(opts.isLv ? {} : {
      ukt_zed_code: f.ukt_zed_code || null,
      depreciation_account_code: f.depreciation_account_code.trim() || null,
    }),
  };
  const payload: Record<string, unknown> = opts.isLv
    ? { ...base, write_off_method: f.write_off_method, quantity: Number(f.quantity) || 1 }
    : {
        ...base,
        asset_group_id: f.asset_group_id,
        depreciation_method_id: f.depreciation_method_id,
        liquidation_value: f.liquidation_value,
        useful_life_months: Number(f.useful_life_months) || 60,
        // ч.1388: порожній податковий строк / вартість = «як у бухобліку» (сервер: NULL).
        tax_depreciable: !!f.tax_depreciable,
        tax_useful_life_months: Number(f.tax_useful_life_months) > 0 ? Number(f.tax_useful_life_months) : null,
        tax_primary_cost: f.tax_primary_cost.trim() !== '' ? f.tax_primary_cost.trim() : null,
        tax_accumulated_depreciation: f.tax_accumulated_depreciation.trim() || '0',
        ...(opts.isIa ? {} : { tax_accelerated: !!f.tax_accelerated }),
        ...(opts.forUpdate && Number(f.tax_useful_life_months) <= 0 ? { reset_tax_useful_life: true } : {}),
        ...(opts.forUpdate && f.tax_primary_cost.trim() === '' ? { reset_tax_primary_cost: true } : {}),
      };
  // Організацію наявної картки змінити не можна — на оновлення її не надсилаємо.
  return opts.forUpdate ? payload : { organization_id: opts.orgId, ...payload };
}
